// extracted by mini-css-extract-plugin
export default {"typewriterContainer":"TypewriterTitle_typewriterContainer__W1jkM","cursor":"TypewriterTitle_cursor__XW7yp","blink":"TypewriterTitle_blink__+JmYz"};